// A8: sunucu `application_state` alanında kanonik teklif durumunu döner (sent, needs_info, recipient_interested,
// alternative_date_proposed, mutually_matched, legacy_discussion, closed, declined, withdrawn). Alan yoksa (çok eski
// istemci verisi) aynı adaptör kuralı burada uygulanır; veri değiştirilmez.
import {FINAL_STATES} from '../constants/eventPlan';

const WHO = {venue: 'Mekânın', organizer: 'Organizatörün'};
export const MATCHED_KEYS = ['mutually_matched', 'legacy_discussion'];
export const ACTIVE_KEYS = ['sent', 'needs_info', 'recipient_interested', 'alternative_date_proposed'];

export function applicationState(item) {
  if (item?.application_state?.key) return item.application_state;
  if (item.withdrawn_at) return {key:'withdrawn',label:'Başvuru geri çekildi',awaiting_role:null};
  if (item.status === 'rejected' || item.venue_response === 'declined') return {key:'closed',label:'Başvuru kapandı',awaiting_role:null};
  if (item.demand_version === 2) {
    const key = item.demand_state === 'discussion' ? 'legacy_discussion' : item.demand_state === 'needs_info' ? 'needs_info' : 'sent';
    return {key, label:key === 'legacy_discussion' ? 'Eski görüşme' : `${WHO[item.awaiting_role] || 'Karşı tarafın'} yanıtı bekleniyor`, awaiting_role:key === 'legacy_discussion' ? item.awaiting_role || null : item.awaiting_role};
  }
  if (item.venue_response === 'accepted') return {key:'legacy_discussion',label:'Eski görüşme',awaiting_role:null};
  if (item.venue_response === 'needs_info') return {key:'needs_info',label:'Organizatörün bilgi vermesi bekleniyor',awaiting_role:'organizer'};
  return {key:'sent',label:'Mekânın yanıtı bekleniyor',awaiting_role:'venue'};
}

export const isMatched = item => MATCHED_KEYS.includes(applicationState(item).key);

// A10: "Bu etkinlik için talebin var" kontrolünün TEK kaynağı (VenueDetail, OrganizerSearch). Sunucu kuralının
// aynasıdır (`server.create_interest`, `demand_engine.create_demand`, `interest_reliability.creation_slot`): aynı
// proje + mekân için durumu açık (new/admin_reviewing/contacted/matched) ve geri çekilmemiş kayıt yeni teklifi
// engeller — etkinlik sonuçlanmış olsa da (iki taraf/personel doğrulaması veya personel reddi). Sonuçlanma
// `completed_at` ya da `concluded_at` ya da son etkinlik durumu ile anlaşılır (`event_plan_model.is_concluded`).
const BLOCKING_STATUSES = ['new', 'admin_reviewing', 'contacted', 'matched'];
export const eventConcluded = plan => !!(plan && (plan.completed_at || plan.concluded_at || FINAL_STATES.includes(plan.event_state)));
export function projectOfferStatus(item) {
  if (!item || !BLOCKING_STATUSES.includes(item.status) || item.withdrawn_at) return null;
  return eventConcluded(item.event_plan) ? 'concluded' : 'open';
}
// { venue_id: 'open' | 'concluded' } — yalnız verilen projenin kayıtları; proje yoksa boş (sunucu da proje dışı
// teklifleri etkinlik özetiyle ayrıca karşılaştırır).
export function projectOfferStatuses(items, projectId) {
  const out = {};
  if (!projectId || !Array.isArray(items)) return out;
  for (const item of items) {
    if (item?.project_id !== projectId) continue;
    const status = projectOfferStatus(item);
    if (status && out[item.venue_id] !== 'open') out[item.venue_id] = status;
  }
  return out;
}
export const applicationChanged = () => window.dispatchEvent(new Event('applications-changed'));
